import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { mixpanelEvent } from "@/lib/mixpanels/mixpanel";
import { Button, IconV2 } from "@bookips/sds";
import { useRouter } from "next/router";
// 사용중 · 사용/기간만료 탭 상단에 공통 노출되는 CTA 2개
// - 이용권 구매하기  → /passes          (기존 구매 페이지)
// - 이용권 코드 등록하기 → /passes/new   (기존 등록 페이지)
const PASSES_URL = "/passes";
const PASSES_NEW_URL = "/passes/new";
// NOTE: 원칙적으로는 Button asChild + <Link> 패턴으로 native <a> 의미(우클릭→새 탭 등)를 유지하는 게 맞지만,
// 현재 SDS Button 의 Slottable 구조상 asChild 시 외부 wrapper 가 <div> 로 렌더되고 <a> 는 텍스트만 감싸서
// 패딩 영역 클릭이 안 먹는 한계가 있다. 우선 onClick + router.push 로 우회하고, 추후 SDS Button 의 asChild
// 구조를 정상화(asChild 대상 요소가 wrapper 가 되도록)하는 게 근본 해결.
const PassActionButtons = ()=>{
    const router = useRouter();
    // MX-621 / MX-622 — Page Default Button Clicked
    const trackCta = (buttonName, buttonUrl)=>{
        mixpanelEvent("Page Default Button Clicked", {
            Position: "이용권 관리",
            "Button Name": buttonName,
            "Button URL": buttonUrl,
            Type: "pass"
        });
    };
    const handleBuy = ()=>{
        trackCta("이용권 구매하기", PASSES_URL);
        router.push(PASSES_URL);
    };
    const handleRegister = ()=>{
        trackCta("이용권 코드로 등록", PASSES_NEW_URL);
        router.push(PASSES_NEW_URL);
    };
    return /*#__PURE__*/ _jsxs("div", {
        className: "flex gap-2 p-5 max-sm:flex-col",
        children: [
            /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "primary",
                size: "md",
                className: "w-full",
                leftElement: /*#__PURE__*/ _jsx(IconV2.Pass, {
                    size: "xs",
                    thick: true
                }),
                onClick: handleBuy,
                children: "이용권 구매하기"
            }),
            /*#__PURE__*/ _jsx(Button, {
                variant: "stroke",
                color: "secondary",
                size: "md",
                className: "w-full",
                onClick: handleRegister,
                children: "이용권 코드 등록하기"
            })
        ]
    });
};
export default PassActionButtons;
